import React, { useEffect } from 'react';
import { FormGroup, InputGroup, FormControl, HelpBlock } from 'react-bootstrap';
import _ from 'lodash';

import FormLabel from '../FormLabel/FormLabel';

export default function InputCollectionInline(props) {
    let hasError = !_.isEmpty(props.errorMessage);

    const labelProps = {
        required: props.required,
        helpText: props.helpText,
        hasError: hasError
    };

    const groupProps = {
        validationState: hasError ? 'error' : null
    };

    let inputControl = props.children;

    if (props.prefix || props.postfix) {
        inputControl = (
            <InputGroup>
                {
                    props.prefix && <InputGroup.Addon>{props.prefix}</InputGroup.Addon>
                }
                {inputControl}
                {
                    props.postfix && <InputGroup.Addon>{props.postfix}</InputGroup.Addon>
                }
            </InputGroup>
        );
    }

    useEffect(() => {
        const optionListContainer = document.getElementsByClassName('optionListContainer')[0];
        if (optionListContainer) {
            optionListContainer.onmousedown = function (e) {
                e.preventDefault();
            };
        }
    });

    return (
        <FormGroup {...groupProps}>
            {
                <div style={{ display: "inline", justifyContent: "space-between"}}>
                    {
                        props.labelText && <FormLabel {...labelProps}>{props.labelText}</FormLabel>
                    }
                    {
                        props.showInfo && <span>{props.infoText}</span>
                    }
                </div>
            }
            {inputControl}
            {
                hasError && <FormControl.Feedback />
            }
            {
                hasError && <HelpBlock><i className="fa fa-exclamation-circle"></i>&nbsp;{props.errorMessage}</HelpBlock>
            }
        </FormGroup>
    );
}